export enum AuthEnums {
  Select = "select",
  Token = "token",
  OAuth = "oauth",
  Guest = "guest",
  EnterName = "enterName",
}

export enum AppTheme {
  LIGHT = "light",
  DARK = "dark",
}
